// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type UpdateInvoiceMutationVariables = Types.Exact<{
  upsertInvoiceDTO: Types.UpsertInvoiceDtoInput;
  additionalProducts: Types.InputMaybe<Array<Types.InputMaybe<Types.UpsertInvoiceAdditionalProductDtoInput>> | Types.InputMaybe<Types.UpsertInvoiceAdditionalProductDtoInput>>;
}>;


export type UpdateInvoiceMutationResult = { __typename?: 'Mutation', updateInvoice: boolean };

export const UpdateInvoiceGql = gql`
    mutation UpdateInvoice($upsertInvoiceDTO: UpsertInvoiceDTOInput!, $additionalProducts: [UpsertInvoiceAdditionalProductDTOInput]) {
  updateInvoice(
    upsertInvoiceDTO: $upsertInvoiceDTO
    additionalProducts: $additionalProducts
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateInvoiceInjectable extends Apollo.Mutation<UpdateInvoiceMutationResult, UpdateInvoiceMutationVariables> {
    override document = UpdateInvoiceGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */